import React from "react";
import CardWithHeader from "../../../../common/components/card/card-with-header";
import {classNames} from "../../../../common/util/util-helpers";
import {fieldsToHtml} from "../../../../common/util/util-fields";
import {RESULT_BADGE_CLASS} from "./dot-inspection-config";

const RESULT_FIELD_NAMES = ['Notes', 'AssignedTechnicianID', 'InspectorID'];

const RESULT_LABEL_KEY = {
    pass: 'text.dot_result_pass',
    fail: 'text.dot_result_fail',
    pending: 'text.dot_result_pending'
};

export default function DotInspectionResultSection({fields, result, onFieldsChange, selects, translate}) {
    const fieldsHtml = fieldsToHtml(
        RESULT_FIELD_NAMES.map((name) => fields[name]),
        translate,
        onFieldsChange,
        selects
    );

    const resultKey = result.result ?? 'pending';

    return (
        <CardWithHeader title={translate('card_header.dot_inspection_result')}>
            <p className="text-sm text-tm-gray-700">
                {translate('text.dot_certification_statement')}
            </p>

            <p className="text-sm text-tm-gray-700">
                {translate('text.dot_inspection_person')}
            </p>

            <div className="flex flex-wrap items-center gap-3">
                <span className={classNames("inline-flex items-center rounded-btn px-3 py-1.5 text-sm font-medium", RESULT_BADGE_CLASS[resultKey])}>
                    {translate(RESULT_LABEL_KEY[resultKey])}
                </span>

                <span className="text-xs text-tm-gray-500">
                    {result.defects > 0
                        ? translate('text.dot_result_note_defects', [result.defects, result.unmarked])
                        : result.unmarked > 0
                            ? translate('text.dot_result_note_unmarked', [result.unmarked])
                            : translate('text.dot_result_note_clean')}
                </span>
            </div>

            <div className="grid grid-cols-6 gap-4">
                {fieldsHtml}
            </div>
        </CardWithHeader>
    );
}
